<template>
  <div v-if="unreadCount > 0" :class="classes">
    {{ unreadCount }}
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useSfAssistantChecksReadStatus } from '@app/application/sf-assistant-checks/stores/assistant-checks-read-status'

interface Props {
  className?: string
  workflowId?: number
}

const props = defineProps<Props>()

const classes = computed(() => {
  return (
    props.className ||
    'sf-label sf-label-danger sf-label-active sf-no-border tw-flex tw-items-center tw-justify-center tw-h-4 tw-min-w-[16px] tw-rounded-full tw-px-1 tw-leading-3'
  )
})

const readStatusStore = useSfAssistantChecksReadStatus()
const { unreadCount } = storeToRefs(readStatusStore)

readStatusStore.fetchUnreadCount(props.workflowId)
</script>
